var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.993,
    height: 12.786,
    viewBox: "0 0 8.993 12.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8473",
    "data-name": "Caminho 8473",
    d: "M220.552,93.215l3.062,3.027a.748.748,0,0,1-1.056,1.06l-1.315-1.32c-.22-.221-.4-.147-.4.163v5.5a.747.747,0,1,1-1.493,0v-5.5c0-.309-.178-.383-.4-.163L217.64,97.3a.748.748,0,0,1-1.056-1.06l3.036-3.025a.663.663,0,0,1,.932,0Zm-4.2-2.111a.749.749,0,1,1,0-1.5h7.494a.749.749,0,1,1,0,1.5Z",
    transform: "translate(-215.602 -89.605)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.e3118adf96a25cc5ebe346e578b0abc4.svg";
export { ForwardRef as ReactComponent };